export default __webpack_public_path__ + "static/media/hht2_ep11_timeline_q01_b.6dc9959e.png";